import React, { use, useLayoutEffect, useState } from 'react';
import { useSidebarControl } from '@topcon/topcon-utils';

import {
  ReviewResultContextType,
  ReviewResultStatus,
} from '../../providers/ReviewResultContext/review-result.types';
import { ReviewResultContext } from '../../providers/ReviewResultContext/review-result.context';
import RequestBusinessPartnerOverview from '../../components/RequestBusinessPartner/steps/RequestBusinessPartnerOverview';
import ReviewRequestBusinessPartnerResultStep from '../../components/RequestBusinessPartner/steps/ReviewRequestBusinessPartnerResultStep';

const ReviewRequestBusinessPartner = () => {
  const { showInDesktopMode, setShowInDesktopMode } = useSidebarControl();
  const { result } = use<ReviewResultContextType>(ReviewResultContext);

  useLayoutEffect(() => {
    if (showInDesktopMode) setShowInDesktopMode(false);
    return () => {
      if (!showInDesktopMode) setShowInDesktopMode(true);
    };
  }, [showInDesktopMode, setShowInDesktopMode]);

  if (result !== null) return <ReviewRequestBusinessPartnerResultStep />;
  return <RequestBusinessPartnerOverview />;
};

function ReviewRequestBusinessPartnerWrapper() {
  const [result, setResult] = useState<ReviewResultStatus | null>(null);
  return (
    <ReviewResultContext value={{ result, setResult }}>
      <ReviewRequestBusinessPartner />
    </ReviewResultContext>
  );
}

export default ReviewRequestBusinessPartnerWrapper;
